import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ArService } from 'src/app/services/ar.service';
import * as moment from 'moment';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { NotifierService } from 'angular-notifier';
import { ValidateCCardNumber, ValidateIsExpiry, validateAllZeros, validateAllCCZeros } from 'src/app/shared/ccard.validator';
import {StoreService} from 'src/stores/setting.store';

@Component({
  selector: 'app-ar-link-inprogress',
  templateUrl: './ar-link-inprogress.component.html',
  styleUrls: ['./ar-link-inprogress.component.scss']
})
export class ArLinkInprogressComponent implements OnInit {

  private notifier2: NotifierService;
    transactionType; 
    tranReservationId;
    paymentTransData = [];
    chequeForm :FormGroup;
    creditCardForm : FormGroup;
    transactionChangeForm : FormGroup;

    activeTab;

    submitted = false;
  capitalOneVisibleOffer: boolean = false;
  capitalOneDiscount: number = 0;
  capitalOneBinNumbers: number[] = [];

  constructor(
    private spinner: NgxSpinnerService, 
    notifierService2: NotifierService,
    private route: ActivatedRoute, 
    private router: Router,
    private authService: AuthenticationService,
    private arService: ArService,
    private storeService: StoreService
    ) {
     // this.activeTab = this.route.snapshot.paramMap.get('tab');
      this.notifier2 = notifierService2;
      this.mask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

      //this.maskUSPhone = ['+', '1', ' ', '(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

      this.maskDate = [ /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];

      this.maskCreditCard = [/\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/];

      this.modelWithValue = '5554441234'

      this.maskUSPhone = [ /\d/, /\d/, /\d/, /\d/];

      this.activeTab = this.route.snapshot.paramMap.get('tid');

     // console.log( this.route.snapshot.paramMap.get('tid'));
  }

  ngOnInit() {
    this.tranReservationId = this.route.snapshot.paramMap.get('id');
    this.getTransactionByID();
    this.initAddtransactionChangeForm();
    localStorage.setItem('arActiveTab', this.activeTab);

    this.storeService.getSettingByKey('core::capitalOneVisibleOffer').subscribe(data => {
      try {
        this.capitalOneVisibleOffer = data ? JSON.parse(data) : false;
      } catch (e) {
        console.error('Error parsing capitalOneVisibleOffer:', e);
        this.capitalOneVisibleOffer = false;
      }
    });

    this.storeService.getSettingByKey('core::capitalOneDiscount').subscribe(data => {
      try {
        this.capitalOneDiscount = data ? JSON.parse(data) : 0;
      } catch (e) {
        console.error('Error parsing capitalOneDiscount:', e);
        this.capitalOneDiscount = 0;
      }
    });

    this.storeService.getSettingByKey('core::capitalOneBinNumbers').subscribe(data => {
      try {
        this.capitalOneBinNumbers = data ? JSON.parse(data) : [];
      } catch (e) {
        console.error('Error parsing capitalOneBinNumbers:', e);
        this.capitalOneBinNumbers = [];
      }
    });
  }
  initAddChequeForm() {
    let st = moment().format('MM/DD/YYYY');
    this.chequeForm = new FormGroup({
      chequeNumber: new FormControl('', Validators.compose([Validators.required])),
      date: new FormControl(st, Validators.compose([Validators.required])),
      notes : new FormControl('', Validators.compose([Validators.required]))
    });
  }

  initAddCreditCardForm() {
    let st = moment().format('MM/DD/YYYY');
    this.creditCardForm = new FormGroup({
      name: new FormControl('', Validators.compose([Validators.required])),
      creditCardNo: new FormControl('', Validators.compose([Validators.required,Validators.pattern('^[0-9 ]{15,19}$'),ValidateCCardNumber, validateAllCCZeros])),
      expireMonthYear: new FormControl('', Validators.compose([Validators.required,ValidateIsExpiry])),
      cvv: new FormControl('', Validators.compose([Validators.required, validateAllZeros])),
    });
  }

  validation_messages = {
    'notes': [
      { type: 'required', message: 'Notes is required.' }
    ],
    'name': [
      { type: 'required', message: 'Card Name is required.' }
    ],
    'creditCardNo': [
      { type: 'required', message: 'Credit card number is required.' },
      { type: 'invaliCCNumber', message: 'Credit card number is invalid.' },
      { type: 'validateAllCCZeros', message: 'Credit card number can not be all zeros'}
    ],
    'expireMonthYear': [
      { type: 'required', message: 'Expire Date is required.' },
      { type: 'pattern', message: 'Expire Date must be MM/YYYY format.' },
      { type: 'isExpiryInvalid', message: 'Expire Date is invalid.' }
    ],
    'cvv': [
      { type: 'required', message: 'CVV is required.' },
      { type: 'validateAllZeros', message: 'CVV can not be all zeros'}
    ],
    'chequeNumber': [
      { type: 'required', message: 'Cheque Number is required.' }
    ]
  }

  get formControls(): any {
    return this.creditCardForm.controls;
  }

  get checkFormControls(): any {
    return this.chequeForm.controls;
  }

  validateCreditDetails(){
    if (this.formControls.name.errors) {
          this.notifier2.notify('warning', 'Please enter Card Name');
          return false;
    }
    if (this.formControls.creditCardNo.errors) {
      this.notifier2.notify('warning', 'Please enter Credit card number');
      return false;
    }
    if (this.formControls.expireMonthYear.errors) {
      this.notifier2.notify('warning', 'Please enter Expire Date');
      return false;
    }
    if (this.formControls.cvv.errors) {
      this.notifier2.notify('warning', 'Please enter CVV');
      return false;
    }
    
  }

  validateCheckDetails(){
    if (this.checkFormControls.chequeNumber.errors) {
      this.notifier2.notify('warning', 'Please enter Cheque Number');
      return false;
    }
    if (this.checkFormControls.notes.errors) {
      this.notifier2.notify('warning', 'Please enter Notes');
      return false;
    }
  }

  initAddtransactionChangeForm() {
    this.transactionChangeForm = new FormGroup({
      subTotal : new FormControl('', Validators.compose([Validators.required])),
      taxes : new FormControl('', Validators.compose([Validators.required])),
      totalAmount : new FormControl('', Validators.compose([Validators.required]))
    });
  }


  initUpdateChangeAmountForm() {
    this.transactionChangeForm = new FormGroup({
      subTotal : new FormControl(this.paymentTransData[0].TRANSACTION_SUBTOTAL, Validators.compose([Validators.required])),
      taxes : new FormControl(this.paymentTransData[0].TRANSACTION_TAXES, Validators.compose([Validators.required])),
      totalAmount : new FormControl(this.paymentTransData[0].TRANSACTION_TOTAL, Validators.compose([Validators.required]))
    });
  }



  taxSlab;
  getTaxSlab(data){
    this.arService.getTaxSlabByStation(data).subscribe(async res => {
      if (res['status']) {
       // console.log(res['status']);
       // console.log(res['result'][0].TAX_SLAB);
        this.taxSlab = res['result'][0].TAX_SLAB;
      } else {
      //  console.log(res['message']);
      }
    }, err => {
     
      console.log(err);
    })
  }


  station;
  getTransactionByID() {
    this.spinner.show();
    this.arService.getInProgressTransactionByResId(this.tranReservationId).subscribe(async res => {
     // this.spinner.hide();
      if (res['status'] && res['result'].length > 0) {
        this.paymentTransData = res['result'];
      //  console.log(this.paymentTransData);
        this.transactionType = this.paymentTransData[0].TRANSACTION_TYPE;
        this.initUpdateChangeAmountForm();
        this.station = this.paymentTransData[0].STATION;
        const data = {
          station: this.station
        }

        this.getTaxSlab(data);
        if(this.paymentTransData[0].TRANSACTION_TYPE == 'Credit Card'){
          this.initAddCreditCardForm();
        }else{
          this.initAddChequeForm();
        }
      }
      this.spinner.hide();
    });
  }

  getMultilTransactionsByID() {
  //  this.spinner.show();
    this.arService.getMultipleTransactionByResId(this.tranReservationId).subscribe(async res => {
     // this.spinner.hide();
      if (res['status'] && res['result'].length > 0) {
        //console.log(res['result']);
      }
    });
  }


  get f(): any {
    return this.transactionChangeForm.controls;
  }


  public myModel: string;
  public modelWithValue: string;

  public mask: Array<string | RegExp>;
  public maskUSPhone: Array<string | RegExp>;
  public maskDate: Array<string | RegExp>;
  public maskCreditCard: Array<string | RegExp>;


  submitTransactionOfPayment(formData){
    this.submitted = true;
   
    if(this.paymentTransData[0].TRANSACTION_TYPE == 'Credit Card'){
    
      this.validateCreditDetails();
      this.creditCardForm.markAllAsTouched();
      if (this.creditCardForm.invalid) {
        return;
      }
  
      let ccNumber = formData.creditCardNo.replace(/\s/g, '');
      var ccExp = formData.expireMonthYear.split("/");
      const expWithYear =  ccExp[1] + ccExp[0]; 

      let ccBrand = 'MC'; 
    
      // if(formData.ccBrand == 'maestro'){
      //     ccBrand = 'MA'
      // } else if(formData.ccBrand == 'visa'){ 
      //   ccBrand = 'VI'
      // }else if(formData.ccBrand == 'mastercard'){ 
      //   ccBrand = 'MC'
      // }else if(formData.ccBrand == 'amex'){ 
      //   ccBrand = 'AX'
      // }else if(formData.ccBrand == 'dinersclub'){ 
      //   ccBrand = 'DN'
      // }else if(formData.ccBrand == 'discover'){ 
      //   ccBrand = 'DS'
      // }else if(formData.ccBrand == 'unionpay'){ 
      //   ccBrand = 'CU'
      // }else if(formData.ccBrand == 'jcb'){ 
      //   ccBrand = 'JC'
      // }


     

    let amount = this.paymentTransData[0].TRANSACTION_TOTAL;
    let finalAmount =  parseFloat(amount).toFixed(2);
      let postData = {
        transactionType  : this.paymentTransData[0].TRANSACTION_TYPE,
        ccAccountNum : ccNumber,
        ccCardVerifyNum : formData.cvv,
        ccExp : expWithYear,
        amount : finalAmount,
        resId : this.paymentTransData[0].RESID,
        country : this.paymentTransData[0].CURRENCY_FLAG,
        ccBrand : ccBrand,
        isCapitalOne: this.isCapitalOneValidate(),
        discountCapitalOne: this.capitalOneDiscount,
       }
       this.spinner.show();
       this.arService.creditCardPaymentsOfTransaction(postData).subscribe(async res => {
        this.spinner.hide();
        if (res['status']) {
          this.notifier2.notify('success', 'Creditcard Payment successfully submitted.');
          setTimeout(r => {
            this.router.navigateByUrl("home/ar-dashboard");
          },2000)
        } else {
          this.notifier2.notify('danger', res['message']);
          // setTimeout(r => {
          //   this.router.navigateByUrl("home/ar-dashboard");
          // },1000)
        }
      }, err => {
        this.spinner.hide();
        this.notifier2.notify('danger', err.message)
        console.log(err);
      })







    }else{
     // console.log(formData)
      this.validateCheckDetails();
      this.chequeForm.markAllAsTouched();
      if (this.chequeForm.invalid) {
        return;
      }

      let postData = {
        transactionType  : this.paymentTransData[0].TRANSACTION_TYPE,
        chequeNo  : formData.chequeNumber,
        paymentClosedDate :new Date(),
        notes : formData.notes,
        resId : this.paymentTransData[0].RESID,
        country : this.paymentTransData[0].CURRENCY_FLAG
       }


       this.arService.creditCardPaymentsOfTransaction(postData).subscribe(async res => {
        this.spinner.hide();
        if (res['status']) {
          this.notifier2.notify('success', 'Payment by Cheque successfully submitted.');
          setTimeout(r => {
            this.router.navigateByUrl("home/ar-dashboard");
          },1000)
      
        } else {
          this.notifier2.notify('danger', 'Payment by cheque method Failed');
        }
      }, err => {
        this.spinner.hide();
        this.notifier2.notify('danger', err.message)
        console.log(err);
      })


    }
  }

  amountChangeStatus = false;
  amountChangeCheckingFn(value){

    // console.log("TaxSlab : ",  this.taxSlab);
 
     const aa =parseFloat(this.paymentTransData[0].TRANSACTION_SUBTOTAL);
     let formSubtotal = parseFloat(value);
    // console.log(event.value)
    if (aa && formSubtotal !== aa) {
 
        // changed amount.
        this.amountChangeStatus = true;
        let taxCal = formSubtotal * (this.taxSlab/100);
 
        let totalAmount = formSubtotal + taxCal ;
 
 
        this.transactionChangeForm.controls['taxes'].setValue(taxCal);
        this.transactionChangeForm.controls['totalAmount'].setValue(totalAmount);
 
       // console.log('Changed:',aa  + " to "  +  formSubtotal + " ---> Tax: " + taxCal + " Toatal Amount : " + totalAmount);
 
    } else {
         //not changed...
         //console.log('Not Changed:',aa , formSubtotal);
         let taxCal = formSubtotal * (this.taxSlab/100);
 
         let totalAmount = formSubtotal + taxCal ;
  
  
         this.transactionChangeForm.controls['taxes'].setValue(taxCal);
         this.transactionChangeForm.controls['totalAmount'].setValue(totalAmount);
  
  
    }
   }
 

//update TrasctionAmount if changes 
   updateTransaction(data) {
   
    this.transactionChangeForm.markAllAsTouched();
    if (this.transactionChangeForm.invalid) {
      return;
    }
   
    const updateData = {
      RESID: this.tranReservationId,
      TRANSACTION_ID: this.paymentTransData[0].TRANSACTION_ID,
      TAX_CALCULATED: data.taxes,
      TRANSACTION_AMOUNT: data.subTotal,
      TRANSACTION_TOTAL_AMOUNT: data.totalAmount,
      LCB_ID: this.authService.getCurrentUserId(),
      CURRENCY_FLAG:this.paymentTransData[0].CURRENCY_FLAG
    }
  
    if(this.amountChangeStatus){
      this.spinner.show();
      this.arService.updatePaymentsOfTransaction(updateData).subscribe(async res => {
        this.spinner.hide();
        this.amountChangeStatus = false;
        if (res['status']) {
          this.notifier2.notify('success', 'Transaction details updated successfully.');
          this.getTransactionByID();
         // this.getMultilTransactionsByID();
        } else {
         this.notifier2.notify('danger', res['message']);
          setTimeout(r => {
            this.router.navigateByUrl("home/ar-dashboard");
          },1000)
        }
      }, err => {
        this.spinner.hide();
        console.log(err);
      })
    }


  }

  markAndCaptureUsingProfile(refernceNumber){
    let amount = this.paymentTransData[0].TRANSACTION_TOTAL;
    let finalAmount =  parseFloat(amount).toFixed(2);
      let postData = {
        transactionType  : this.paymentTransData[0].TRANSACTION_TYPE,
        amount : finalAmount,
        RESID : this.paymentTransData[0].RESID,
        CURRENCY_FLAG : this.paymentTransData[0].CURRENCY_FLAG,
        PROF_CUST_REFNUM: refernceNumber
       }
       this.spinner.show();
       this.arService.profilePaymentsOfTransaction(postData).subscribe(async res => {
        this.spinner.hide();
        if (res['status']) {
          this.notifier2.notify('success', 'Payment by profile is successfully submitted.');
          setTimeout(r => {
            this.router.navigateByUrl("home/ar-dashboard");
          },3000)
      
        } else {
          this.notifier2.notify('danger', res['message']);
          setTimeout(r => {
            this.router.navigateByUrl("home/ar-dashboard");
          },3000)
        }
      }, err => {
        this.spinner.hide();
        this.notifier2.notify('danger', err.message)
        console.log(err);
      })
         
  }

  captureCCardAmount(data){
    const ccData = {
      RESID : data.RESID,
      TXREFNUM :data.TXREFNUM,
      CURRENCY_FLAG:data.CURRENCY_FLAG
    }
    this.spinner.show();
    this.arService.multiACTransactionForCC(ccData).subscribe(async res => {
      this.spinner.hide();
      if(res['status']){
        this.notifier2.notify('success', 'Payment captured successfully');
        setTimeout(r => {
          this.router.navigateByUrl("home/ar-dashboard");
        },3000)

      }else{
        this.notifier2.notify('warning',res['message']);
          setTimeout(r => {
            this.router.navigateByUrl("home/ar-dashboard");
          },3000)
        
      }
    });
  }


  onBack() {
    this.router.navigateByUrl("home/ar-dashboard");
  }

  getTime(date) {
    return moment.utc(date).format('MMM DD, YYYY HH:mm')
  }
  getTimeFormat(date){
    return moment.utc(date).format('MM/DD/YY, hh:mm a');
  }
  getDateFormat(date){
    return moment.utc(date).format('MM/DD/YY');
  }
  getCapitalOneBin(cardNumber) {
    const cleanNumber = cardNumber.replace(/\D/g, '');
    return parseInt(cleanNumber.substring(0, 6), 10);
  }
  isCapitalOneValidate(): boolean {
    const cardNumber = this.creditCardForm.get('creditCardNo').value;
    if(!cardNumber && !this.capitalOneVisibleOffer) return false;
    const bin = this.getCapitalOneBin(cardNumber);
    return this.capitalOneBinNumbers.includes(bin);
  }
}
